module.exports = __webpack_public_path__ + "img/apply-banner.5f7d7fce.png";